// extracted by mini-css-extract-plugin
export default {"transparentLabel":"ProductParameterForm_transparentLabel__82HhQ","deleteButton":"ProductParameterForm_deleteButton__Zr5QC","addButton":"ProductParameterForm_addButton__I72YQ"};